import React from "react";
import {
  Notification,
  NotificationColorSchemeEnum,
  NotificationKindEnum,
} from "../../../components/base_ui/progress_and_validation/notification/index";
import { Survey } from "../../../generated/graphql";
import QuestionErrorItem from "./question_error_item";
import styled from "styled-components";
import { SurveyAudienceContext } from "../../survey_page";
import { Cell } from "baseui/layout-grid";

const notificationOverrides = {
  Body: {
    style: () => ({
      // This lets the grid control the margins of its content
      marginLeft: 0,
      marginRight: 0,
      marginBottom: 0,
      marginTop: 0,
    }),
  },
};

const StyledBoldText = styled.span`
  font-weight: 700;
  text-align: left;
`;

const StyledList = styled.ul`
  list-style-position: outside;
  margin-top: 0;
  margin-left: ${({ theme }) => `-${theme.sizing.scale600}`};
  margin-bottom: 0;
  padding-inline-start: 40px;
`;

export default function NotificationForQuestionErrors({
  questionsWithErrors,
  onClose,
  surveyAudienceContext,
}: {
  questionsWithErrors: Survey["questions"];
  onClose: () => void;
  surveyAudienceContext?: SurveyAudienceContext;
}) {
  const isPlural = questionsWithErrors.length > 1;
  // It's necessary to separate this out explicitly so screen readers can determine what to read out.
  const boldErrorText = isPlural
    ? "Errors found in the following questions."
    : "Error found in the following question.";

  return (
    <Cell span={12}>
      <div id={"survey-validation-message"}>
        <Notification
          kind={NotificationKindEnum.NEGATIVE}
          colorScheme={NotificationColorSchemeEnum.LIGHT}
          showIcon={true}
          closeable={true}
          isFullWidth={true}
          onClose={onClose}
          dataTest={"survey-error-validation-message"}
          styletronOverrides={notificationOverrides}
        >
          <div>
            <StyledBoldText>{boldErrorText}</StyledBoldText> Please review them before resubmitting:
            <StyledList>
              {questionsWithErrors
                .sort((q1, q2) => q1.index - q2.index)
                .map((question) => {
                  return (
                    <QuestionErrorItem
                      key={question.id}
                      question={question}
                      surveyAudienceContext={surveyAudienceContext}
                    />
                  );
                })}
            </StyledList>
          </div>
        </Notification>
      </div>
    </Cell>
  );
}
